import Enum from "../../../../../../enums/Enum";

const DurationTimeEnum = new Enum({
    DAY: {name: "Day", nameInArabic: "يوم"},
    WEEK: {name: "Week", nameInArabic: "أسبوع"},
    MONTH: {name: "Month", nameInArabic: "شهر"},
    YEAR: {name: "Year", nameInArabic: "سنة"}
});

export default DurationTimeEnum;